/// <amd-module name="Agile/Sprints/Directory/Redux/SprintsDirectorySelectors" />
import { IArtifactOwner } from "Agile/Directory/DirectoryContracts";
import { ISprintDirectoryViewState } from "Agile/Sprints/Directory/SprintDirectoryContracts";
import { getAllOwners } from "Agile/Directory/Redux/DirectorySelectors";
import * as Reselect from "Reselect";

export function getAllTeams(state: ISprintDirectoryViewState): IArtifactOwner[] | undefined {
    return state.sprintDirectoryState.allTeams;
}

export function getPageSize(state: ISprintDirectoryViewState): number | undefined {
    return state.sprintDirectoryState.pageSize;
}

export function isSprintPaneOpen(state: ISprintDirectoryViewState): boolean {
    return state.sprintDirectoryState.isSprintPaneOpen;
}

export function getEditSprintDetails(state: ISprintDirectoryViewState): { iterationId: string; team: { id: string; name: string } } | undefined {
    return state.sprintDirectoryState.editSprintInformation;
}

export function getSprintOwners(state: ISprintDirectoryViewState): IArtifactOwner[] {
    const allTeams = getAllTeams(state);
    if (!allTeams) {
        return getAllOwners(state);
    } else {
        return allTeams;
    }
}

export const areSprintsPaged = Reselect.createSelector(
    [getAllTeams, getPageSize],
    (allTeams: IArtifactOwner[] | undefined, pageSize: number | undefined): boolean => {
        return allTeams && pageSize ? allTeams.length > pageSize : false;
    }
);
